
export default function (value, countCharacters = 500, withoutDots = false) {
    let val = value.length > countCharacters ? value.slice(0, countCharacters - 1) : value
    return `${val}${withoutDots ? '' : "…"}`.trim()
}
